/** @jsx jsx */
import { jsx, } from '@emotion/core';
import { Overlay, } from '@argo/base-patterns';

export default ({ isOpen, overlayHeader, closeOverlay, },): JSX.Element => (
  <Overlay
    showOverlay={isOpen}
    header={overlayHeader}
    headingStyle="ContentHeadingSemi"
    headingTag="h4"
    enableTitleCase={false}
    widthRatio={75}
    maxHeightRatio={60}
    useOpenContent={false}
    onClose={() => { closeOverlay(); }}
  >
    For more infomation, visit Kelley Blue Book&apos;s KBB.com. Kelley Blue Book is a registered trademark of Kelley Blue Book Co., Inc.
  </Overlay>
);
